import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useState, useRef } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { episodeAction } from '../../actions/episodeAction';
import { DABInlineLoading } from '../../components/dab';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';

interface IUserProps {
	dispatch: Dispatch<any>;
	episodeData: any;
	userId: any;
	fromPage: string;
}

const ChannelEngegement: React.SFC<IUserProps> = ({
	dispatch, episodeData, userId, fromPage }) => {

	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [graphOptions, setGraphOptions] = useState({});
	const barChartSingleComponentRef = useRef<HighchartsReact.RefObject>(null);

	const year: number = moment().year()

	const handleRefreshGraph = (data) => {
		setGraphOptions({
			chart: {
				type: 'area'
			},
			title: {
				text: 'User Episode Counts by Channel'
			},
			xAxis: {
				categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			},
			yAxis: {
				min: 0,
				title: {
					text: 'Number Of Episodes'
				}
			},
			plotOptions: {
				series: {
					allowPointSelect: true,
					marker: {
						states: {
							select: {
								fillColor: 'red',
								lineWidth: 0
							}
						}
					}
				}
			},
			series: data
		});
	};

	React.useEffect(() => {
		dispatch(episodeAction.episodeGetUserCountByYear({ year: year, userId: userId }));
	}, [userId]);

	if (!isDataLoaded) {
		if (episodeData.isListSuccess) {
			setIsDataLoaded(true);
			episodeData.isListSuccess = false;
			var data = [{}]; data = [];
			var monthData = [0];

			episodeData.items.forEach((item) =>
			{

				monthData = [];
				item.messageCounts.forEach((countData) =>
				{
					monthData.push(countData.count);
				});
				data.push({ name: item.title, data: monthData });
			});
			handleRefreshGraph(data);
		}
	}

	return (
		<div className="channel-engagement">
			{fromPage !== "front" ? <h5 >
				<span data-testid="chanelEngagementChartTitle">Channel Engagement</span>
			</h5> : ""}
				<div className='card-box'>
					<div className='card-box-graph' data-testid="chanelEngagementChart">
					{episodeData && episodeData.isLoading ? <DABInlineLoading /> :
						episodeData && episodeData.items && episodeData.items.length > 0 ?
							<HighchartsReact
							containerProps={{ style: { height: "100%", width: "100%", padding: "0" } }}
							highcharts={Highcharts}
							options={graphOptions}
							ref={barChartSingleComponentRef}
							/>
						:
						<div className={fromPage !== "front" ? "card-box on-empty" : ""}>
								<h5 className="text-center">No data found</h5>
						</div>
					}
					</div>
				</div> 
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { episodeData } = state;
	return {
		episodeData
	};
};

export default connect(mapStateToProps)(ChannelEngegement);